export enum Authority {
  ADMIN = 'ADMIN',
  EMPLOYEE = 'EMPLOYEE',
}
